
export default function Title () {

    return <div className="titleBack">
        <p className="loginTitle">
        <span className="bigger headerTitle ">K</span>{" "}
        <span className="big">chat</span>
        </p>
        </div>
}